import { Component, Input, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { NotifierService } from "angular-notifier";
import {
  AngularGridInstance,
  GridOdataService,
  GridOption,
  FieldType,
} from "angular-slickgrid";
import { COMMA, ENTER } from "@angular/cdk/keycodes";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { Subscription } from "rxjs";
import { RestApiService } from "../rest-api.service";
import { MessageService } from "../message.service";
import { ActivatedRoute, Router } from "@angular/router";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
// import resizePolyfill from 'resize-polyfill';
// import {TranslateService} from '@ngx-translate/core';
import { ResizeEvent } from "angular-resizable-element";
import { FormControl } from "@angular/forms";

const defaultPageSize = 50;

interface UserDetails {
  login_name: string;
  // other properties...
}

@Component({
  selector: "app-create-ticket-cit-apps",
  templateUrl: "./create-ticket-cit-apps.component.html",
  styleUrls: ["./create-ticket-cit-apps.component.css"],
})
export class CreateTicketCitAppsComponent implements OnInit, OnDestroy {
  height: number;
  radioButton: any;
  displayed = false;
  reactiveSearchDisplay = false;
  preventiveRadioCheck = false;
  reactiveRadioCheck = false;
  subRadioDisplay = false;
  ticketTypes: any;
  searchField: string;
  name: string;
  desc: string;
  brief: string;
  rDate = "";
  dDate = "";
  urgency: number;
  impact: number;
  clientId: any;
  priority: string;
  notifier: NotifierService;
  respObject: any;
  urgencies = [];
  impacts = [];
  radioChecked: any;
  cat = [];
  searchCat = [];
  priorityId = 0;
  attachment = [];
  uploadButtonName = "Upload File";
  fileUploadUrl: string;
  add = false;
  dynamicFields = [];
  priorityType: number;
  columnDefinitions = [];
  ticketColumnDefinitions = [];
  ticketColumn = [];
  columVal: string;
  descId: number;
  attrVal: string;
  gridOptions: GridOption;
  gridOptions2: GridOption;
  dataset: any[];
  angularGrid: AngularGridInstance;
  angularGrid2: AngularGridInstance;
  gridObj: any;
  gridObj2: any;
  selectedTitles: any[];
  selectedTitles2 = [];
  Tickets = [];
  show: boolean;
  selected: number;
  data = [];
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  selectable = true;
  removable = true;
  addOnBlur = true;
  masterNameSelected: number;
  columnNameSelected: number;
  masterNameObj = [];
  columnNameObj = [];
  columnDataObj = [];
  columnValueObj = [];
  masterName: string;
  totalData: number;
  attrValue = [];
  columnData = [];
  start = 0;
  types = [];
  menus = [];
  totalItems: number;
  public modalRef: NgbModalRef;
  columnData2 = [];
  clientName: String;
  columnName: string;
  assetValue: string;
  page: number;
  collectionSize: number;
  pageSize: number;
  private subTypeSeq: string;
  private subTypeId: string;
  typeSeq: number | any | string;
  subtypes = [];
  searchTid: string;
  inciId: number;
  ticketCount: number;
  addedTicket = [];
  dataLoaded = true;
  ticketTypeLoaded = false;
  categoryLoaded = false;
  private baseCategories = [];
  private userAuth: Subscription;
  private ticketTypeSubscription: Subscription;
  hideAttachment: boolean;
  attachMsg: string;
  rsdbData: any;
  role = [];
  roleSelected: number;
  private roleId: number;
  isAnalyst: boolean;
  type: string;
  @ViewChild("loginName") private loginName;
  @ViewChild("ticketcontent") private ticketcontent;
  empId: string;
  userGroups = [];

  ticketAllTypes: any;
  ticketDetails: any;
  solutions = [];
  tId: number;
  @ViewChild("groupSelect") private groupSelect;
  private dialogRef: MatDialogRef<any, any>;
  userGroupSelected: number;
  userGroupId: number;
  private sourceType: string;
  private email: string;
  private mobile: string;
  private createbyId: string;
  private user: string;
  userName: string;
  private psDetails: any;
  groupName: string;
  private selectedCatVal = 0;
  grpLevel: number;
  isLowestLevel: boolean;
  claimNo = "";
  hideClaim = true;
  searchDtls = [];
  panelOpenState = false;
  @ViewChild("tab") private tab;
  selectedTab: number;
  public parentTypeSeq: number;
  allStatus = [];
  statusSelected: number;
  startDate: any;
  endDate: any;
  inciCategories = [];
  ticketIdSearchLoaded: boolean;
  filterSearchLoaded: boolean;
  isBlankRequester = false;
  isBlankDesc = false;
  isBlankLong = false;
  isBlankPriority = false;
  isBlankClaim = false;
  private storage: any;
  private storage2: any;
  cat1: any;
  cat2: any;
  cat3: any;
  fromDate: string;
  toDate: string;
  minDate: any;
  maxDate: any;
  islead: boolean;
  formdata: any;
  service: any;
  nextOffset = 0;
  searchPageSize: number;
  top: number;
  skip: number;
  query: any;
  isCreateTicket: boolean;
  @Input() parrentTicketId = "";
  @Input() wfcresultId = "";
  @Input() hideNotifier: boolean;
  assetCount = 0;
  hideCr: boolean;
  hidePr: boolean;
  MAX_FILE_UPLOAD = 10;
  isContractUser: boolean;
  isContractDisabled: boolean;
  disabledCount: number;
  searchUser: FormControl = new FormControl();
  userDtl = [];
  isLoading = false;
  userSelected: string;
  private attachFile: number;
  selectedLogiName: any;
  selectedEmail: any;
  selectedMobile: any;
  selectedName: any;
  selectedId: any;
  // userDtl: UserDetails;

  constructor(
    private _rest: RestApiService,
    notifier: NotifierService,
    private messageService: MessageService,
    private route: Router,
    private modalService: NgbModal,
    private dialog: MatDialog
  ) {
    this.notifier = notifier;
  }

  angularGridReady(angularGrid: AngularGridInstance) {
    this.angularGrid = angularGrid;
    this.gridObj = (angularGrid && angularGrid.slickGrid) || {};
    this.columnData = this.gridObj.getColumns();
  }

  angularGridReady2(angularGrid: AngularGridInstance) {
    this.angularGrid2 = angularGrid;
    this.gridObj2 = (angularGrid && angularGrid.slickGrid) || {};
    this.columnData2 = this.gridObj2.getColumns();
  }

  ngOnInit() {
    this.attachFile = 0;
    this.hideCr = false;
    this.hidePr = false;
    this.isCreateTicket = true;
    this.searchPageSize = 0;
    this.skip = 0;
    this.totalItems = 0;
    if (/Edge/.test(navigator.userAgent)) {
      this.height = 120;
    }
    this.islead = false;
    this.isContractDisabled = true;
    this.toDate = "";
    this.fromDate = "";
    this.isContractUser = false;
    const now = new Date();
    const nowDate = new Date();
    const nowMonth = nowDate.getMonth();
    const nowDay = nowDate.getDate();
    const nowYear = nowDate.getFullYear();
    this.maxDate = new Date(nowYear, nowMonth, nowDay);
    // this.toDate = this.formatDate(this.maxDate);
    this.endDate = this.messageService.ticketConverter(this.maxDate, 1);
    const previousDate = new Date(now.setDate(now.getDate() - 1));
    const previousMonth = previousDate.getMonth();
    const previousDay = previousDate.getDate();
    const previousYear = previousDate.getFullYear();
    this.minDate = new Date(previousYear, previousMonth, previousDay);
    // this.fromDate = this.formatDate(this.minDate);
    this.startDate = this.messageService.ticketConverter(this.minDate, 1);
    // if (/MSIE \d|Trident.*rv:/.test(navigator.userAgent)) {
    //     const el = document.getElementsByClassName('brief-desc');
    //     resizePolyfill(el, true);
    // }
    this.page = 1;
    this.pageSize = 100;
    this.isAnalyst = false;
    this.hideAttachment = true;
    this.masterNameSelected = 0;
    this.userGroups = [];
    this.name = "";
    this.desc = "";
    this.brief = "";
    this.fileUploadUrl = this._rest.apiRoot + "/updateFile";
    this.gridOptions = {
      enableAutoResize: true, // true by default
      enableCellNavigation: true,
      enableFiltering: true,
      editable: true,
      rowSelectionOptions: {
        selectActiveRow: false,
      },
      enableCheckboxSelector: true,
      enableRowSelection: true,
    };

    // this.gridOptions2 = {
    //     enableAutoResize: true,       // true by default
    //     enableCellNavigation: true,
    //     enableFiltering: true,
    //     editable: true,
    //     rowSelectionOptions: {
    //         selectActiveRow: false
    //     },
    //     enableCheckboxSelector: true,
    //     enableRowSelection: true,
    // };
    this.service = new GridOdataService();
    this.gridOptions2 = {
      enableAutoResize: true,
      autoResize: {
        containerId: "demo-container",
        sidePadding: 15,
      },
      rowSelectionOptions: {
        selectActiveRow: false,
      },
      checkboxSelector: {
        // you can toggle these 2 properties to show the "select all" checkbox in different location
        // hideInFilterHeaderRow: false,
        // hideInColumnTitleRow: true
      },
      enableCellNavigation: true,
      enableFiltering: true,
      enableCheckboxSelector: true,
      enableRowSelection: true,
      // enableTranslate: true,
      // i18n: this.translate,
      pagination: {
        // pageSizes: [10, 15, 20, 25, 30, 40, 50, 75, 100],
        pageSizes: [50, 100, 200, 300, 400, 500, 600, 750, 1000],
        pageSize: defaultPageSize,
        totalItems: 0,
      },
      presets: {
        // you can also type operator as string, e.g.: operator: 'EQ'
        // filters: [
        //   { columnId: 'gender', searchTerms: ['male'], operator: OperatorType.equal },
        // ],
        // sorters: [
        //   // direction can be written as 'asc' (uppercase or lowercase) and/or use the SortDirection type
        //   { columnId: 'name', direction: 'asc' }
        // ],
        pagination: { pageNumber: 1, pageSize: defaultPageSize },
      },
      backendServiceApi: {
        service: new GridOdataService(),
        // preProcess: () => this.displaySpinner(true),
        process: (query) => this.setParameter(query),
        // postProcess: (response) => {
        //     // this.statistics = response.statistics;
        //     // this.displaySpinner(false);
        //     this.displayTicket(response);
        // }
      },
    };

    if (
      this.messageService.getUserId() === null ||
      this.messageService.getToken() === null
    ) {
      this.messageService.clearSession();
      window.location.href = this.messageService.API_ROOT;
    } else {
      this.sourceType = "CIT Portal";
      if (this.messageService.clientId) {
        this.clientId = this.messageService.clientId;
        this.clientName = this.messageService.client;
        this.userGroups = this.messageService.groupId;
        this.email = this.messageService.email;
        this.mobile = this.messageService.mobile;
        this.user = this.messageService.name;
        this.userName = this.messageService.loginName;

        console.log(
          "this.messageService.loginName ===",
          this.messageService.loginName
        );

        // this.groupName = this.userGroups[0].grpName;
        // this.userGroupId = this.userGroups[0].groupId;
        if (this.userGroups !== undefined) {
          if (this.messageService.getSupportGroup() === null) {
            this.userGroupId = this.userGroups[0].groupId;
            this.groupName = this.userGroups[0].grpName;
            this.grpLevel = this.userGroups[0].level;
          } else {
            const group = this.messageService.getSupportGroup();
            this.userGroupId = group.groupId;
            this.groupName = group.grpName;
            this.grpLevel = group.level;
          }
          this.userGroupSelected = this.userGroupId;
        }
        this.onPageLoad();
      } else {
        this.userAuth = this.messageService
          .getClientUserAuth()
          .subscribe((auth) => {
            this.clientId = auth[0].clientId;
            this.clientName = auth[0].client;
            this.userGroups = auth[0].groupId;
            this.email = auth[0].email;
            this.mobile = auth[0].mobile;
            this.user = auth[0].name;
            this.userName = auth[0].login_name;
            // this.groupName = this.userGroups[0].grpName;
            // this.userGroupId = this.userGroups[0].groupId;
            if (this.userGroups !== undefined) {
              if (this.messageService.getSupportGroup() === null) {
                this.userGroupId = this.userGroups[0].groupId;
                this.groupName = this.userGroups[0].grpName;
                this.grpLevel = this.userGroups[0].level;
              } else {
                const group = this.messageService.getSupportGroup();
                this.userGroupId = group.groupId;
                this.groupName = group.grpName;
                this.grpLevel = group.level;
              }
              this.userGroupSelected = this.userGroupId;
            }
            this.onPageLoad();
            // }
          });
      }
    }

    this.searchUser.valueChanges.subscribe((psOrName) => {
      if (psOrName !== undefined && psOrName.length > 4) {
        this.isLoading = true;
        this._rest.searchUserDetails(this.clientId, psOrName).subscribe(
          (res1) => {
            console.log("searchUserDetails res1 ==== >>>", res1);

            this.respObject = res1;
            this.isLoading = false;
            if (this.respObject.success) {
              this.userDtl = this.respObject.details;
              console.log("searchUserDetails userDtl ==== >>>", this.userDtl);

              for (let i = 0; i < this.userDtl.length; i++) {
                const user = this.userDtl[i];
                this.selectedId = user.id;
                this.selectedLogiName = user.login_name;
                this.selectedEmail = user.email;
                this.selectedMobile = user.mobile;
                this.selectedName = user.name;
            }

              console.log(
                "searchUserDetails selectedId ==== >>>",
                this.selectedId
              );
              console.log(
                "searchUserDetails selectedLogiName ==== >>>",
                this.selectedLogiName
              );
              console.log(
                "searchUserDetails selectedEmail ==== >>>",
                this.selectedEmail
              );
              console.log(
                "searchUserDetails selectedMobile ==== >>>",
                this.selectedMobile
              );
              console.log(
                "searchUserDetails selectedName ==== >>>",
                this.selectedName
              );
            } else {
              this.notifier.notify("error", this.respObject.errorMessage);
            }
          },
          (err) => {
            this.isLoading = false;
            this.notifier.notify("error", this.messageService.SERVER_ERROR);
          }
        );
      } else {
        this.userDtl = [];
      }
    });
  }




  changeId($event) {
    console.log("change id", $event);




    this.sourceType = "Call";
    if (this.userDtl.length > 0) {
        for (let i = 0; i < this.userDtl.length; i++) {
            console.log("inside for");
            
            const user = this.userDtl[i];
            this.selectedLogiName = user.login_name;
            this.selectedEmail = user.email;
            this.selectedMobile = user.mobile;
            this.selectedId = user.id;
            this.name =
                this.selectedLogiName +
                "-" +
                this.messageService.xorEncode(
                    atob(this.selectedEmail),
                    this.messageService.SECRET_TOKEN
                ) +
                "-" +
                this.messageService.xorEncode(
                    atob(this.selectedMobile),
                    this.messageService.SECRET_TOKEN
                );

            this.createbyId = this.selectedId;


            this.getRSDBData("2");
            this.dialog.closeAll();
        }
    }
}



//   changeId($event) {
//     console.log("change id", $event);

//     this.sourceType = "Call";
//      this.name = this.userDtl[0].login_name + '-' + this.messageService.xorEncode(atob(this.userDtl[0].email),
//          this.messageService.SECRET_TOKEN) +
//        '-' + this.messageService.xorEncode(atob(this.userDtl[0].mobile), this.messageService.SECRET_TOKEN);




//     this.createbyId = this.userDtl[0].id;

//     this.getRSDBData("2");
//     this.dialog.closeAll();
//   }

  setParameter(query) {
    return new Promise((resolve, reject) => {
      this.query = query;
      // const queryParams = query.toLowerCase().split('&');
      // for (const param of queryParams) {
      //     if (param.includes('$skip=')) {
      if (this.fromDate !== "" || this.toDate !== "") {
        this.searchTicketWithFilter(this.query, 0);
      }
      // }
      // }
      resolve(this.query);
    });
  }

  searchFaq(value) {
    if (this.typeSeq === 1) {
      if (value.length > 2) {
        this._rest
          .getFaqSearchData(
            this.clientId,
            value,
            this.messageService.getUserId()
          )
          .subscribe(
            (res) => {
              this.respObject = res;
              if (this.respObject.success) {
                this.selectedTab = 1;
                this.searchDtls = this.respObject.details;
              }
            },
            (err) => {
              this.notifier.notify("error", this.messageService.SERVER_ERROR);
            }
          );
      } else if (value.length === 0) {
        this.searchDtls = [];
      }
    }
  }

  onSelectGroup() {
    // // console.log(target);
    if (this.userGroupSelected !== 0) {
      this.userGroupId = this.userGroupSelected;
      for (let i = 0; i < this.userGroups.length; i++) {
        if (this.userGroups[i].groupId === this.userGroupId) {
          this.groupName = this.userGroups[i].grpName;
          this.grpLevel = this.userGroups[i].level;
        }
      }
      if (this.grpLevel === 0) {
        this.isLowestLevel = true;
      }
      this.messageService.saveSupportGroup({
        groupId: this.userGroupId,
        grpName: this.groupName,
        level: this.grpLevel,
      });
      this.onPageLoad();
    }
  }

  // getPSDetails(psNo, type) {
  //     this.createbyId = '';
  //     this.dataLoaded = false;
  //     this._rest.getPsDetails(psNo).subscribe((res1) => {
  //         this.respObject = res1;
  //         this.dataLoaded = true;
  //         // if (this.respObject.success) {
  //         if (!this.messageService.isEmptyJSON(this.respObject)) {
  //             this.psDetails = this.respObject.Table[0];
  //             this._rest.getUserDetailsByLoginId(this.clientId, psNo).subscribe((res) => {
  //                 this.respObject = res;
  //                 if (this.respObject.success) {
  //                     this.name = this.psDetails.PSNO + ':' + this.psDetails.NAME + ':' +
  //                         this.psDetails.GRADE + ':' + this.psDetails.UNIT;
  //                     const details = this.respObject.details;
  //                     this.createbyId = details[0].id;
  //                     this.getRSDBData('2');
  //                     this.getPriority();
  //                 } else {
  //                     if (this.isLowestLevel || type === 'change') {
  //                         this.notifier.notify('error', this.messageService.USER_NOT_FOUND_SYSTEM);
  //                     }
  //                 }
  //             });
  //         } else {
  //             if (this.isLowestLevel || type === 'change') {
  //                 this.notifier.notify('error', this.messageService.USER_NOT_FOUND_SYSTEM);
  //             }
  //         }
  //         // }
  //     }, (err) => {
  //         this.dataLoaded = true;
  //         if (this.isLowestLevel || type === 'change') {
  //             this.notifier.notify('error', this.messageService.USER_NOT_FOUND_NETWORK);
  //         }
  //     });
  // }

  getPriority() {
    let priorityType;
    if (this.psDetails) {
      priorityType = this.psDetails.SM;
    } else {
      priorityType = "";
    }
    this._rest
      .getPriorityForLTSSC(
        this.messageService.getUserId(),
        this.clientId,
        this.radioChecked,
        priorityType
      )
      .subscribe(
        (res) => {
          this.respObject = res;
          this.priority = "";
          this.priorityId = 0;
          if (this.respObject.success) {
            if (this.respObject.details.length > 0) {
              this.priority = this.respObject.details[0].name;

              console.log(
                "this.respObject.details[0].name",
                this.respObject.details[0].name
              );

              this.priorityId = this.respObject.details[0].id;
            }
          } else {
            this.notifier.notify("error", this.respObject.errorMessage);
          }
        },
        (err) => {
          this.notifier.notify("error", this.messageService.SERVER_ERROR);
        }
      );
  }

  onPageLoad() {
    this.formdata = { clientId: this.clientId };
    this.isLowestLevel = false;
    // this.createbyId = this.messageService.getUserId();
    if (this.grpLevel === 0) {
      this.isLowestLevel = true;
      this.getRequesterInfoDetails();
      this.createbyId = this.messageService.getUserId();
    }

    // this.createbyId = this.messageService.getUserId();
    this.ticketTypeSubscription = this._rest
      .getTicketTypeForTicketCreation_LNT(this.clientId, this.userGroupId)
      .subscribe(
        (res1) => {
          this.respObject = res1;
          // // console.log('ticket type=', JSON.stringify(this.respObject));
          this.ticketTypeLoaded = true;
          if (this.respObject.success) {
            this.storage = JSON.parse(sessionStorage.getItem("dd"));
            this.storage2 = JSON.parse(sessionStorage.getItem("cat1"));
            // console.log('vvvvvvvvvvvvvvvv' + this.storage2);
            if (this.storage2 !== null) {
              this.cat1 = this.storage2.cat1;
              this.cat2 = this.storage2.cat2;
              this.cat3 = this.storage2.cat3;
            }
            // console.log('session =======================>' +  JSON.stringify(this.storage2)  + this.cat1 + this.cat2 + this.cat3);

            // this.radioChecked = this.respObject.details[0].id;
            this.typeSeq = this.respObject.details[0].seq;
            if (
              (this.typeSeq === 1 || this.typeSeq === 5) &&
              this.respObject.details[0].asset === "true"
            ) {
              this.displayed = true;
            } else {
              this.displayed = false;
            }

            this.radioButton = this.respObject.details;
            for (let i = 0; i < this.radioButton.length; i++) {
              if (this.radioButton[i].seq === 1) {
                this.inciId = this.radioButton[i].id;
                break;
              }
            }
            // ==============================================================
            if (this.storage === null) {
              this.radioChecked = this.radioButton[0].id;
              // console.log('----:' + this.radioButton[0].id);
              this.typeSeq = this.radioButton[0].seq;
              this.parentTypeSeq = this.radioButton[0].seq;
            } else {
              const type = this.storage.type;
              this.radioButton[0].checked = false;
              for (let i = 0; i < this.radioButton.length; i++) {
                // console.log(this.types[i].id, type);
                if (this.radioButton[i].id === type) {
                  this.radioChecked = this.radioButton[i].id;
                  this.radioButton[i].checked = true;
                  this.typeSeq = this.radioButton[i].seq;
                  this.parentTypeSeq = this.radioButton[i].seq;
                  break;
                }
              }
              // console.log('seq---------> : ' + this.seq);
            }
            this.getRSDBData("2");
            // console.log('--------->' + this.radioChecked + '=====' + typeof this.radioChecked);
            if (Number(this.typeSeq) === 5) {
              this.hideCr = true;
            } else {
              this.hideCr = false;
            }

            if (Number(this.typeSeq) === 6) {
              this.hidePr = true;
            } else {
              this.hidePr = false;
            }

            // ====================================================================
            this._rest
              .checkIsLead(
                this.clientId,
                this.userGroupId,
                this.messageService.getUserId()
              )
              .subscribe((res3) => {
                this.respObject = res3;
                if (this.respObject.success) {
                  this.islead = this.respObject.details[0].is_spoc;
                  if (this.storage2 !== null) {
                    this.getTicketLoadingDataWithAttr();
                  } else {
                    this.getTicketLoadingDataWithAttr2();
                    // console.log('ssc api ===========================>>');
                  }
                } else {
                }
              });
          } else {
            this.notifier.notify("error", this.respObject.errorMessage);
          }
        },
        (err) => {
          this.notifier.notify("error", this.messageService.SERVER_ERROR);
        }
      );
  }

  handleSelectedRowsChanged(e, args) {
    if (Array.isArray(args.rows)) {
      this.selectedTitles = args.rows.map((idx) => {
        const item = this.gridObj.getDataItem(idx);
        return item || "";
      });

      if (this.selectedTitles.length > 0) {
        this.show = true;
        this.selected = this.selectedTitles.length;
      } else {
        this.show = false;
      }
      // // console.log(JSON.stringify(this.selectedTitles));
    }
  }

  handleSelectedRowsChanged2(e, args) {
    console.log(args);
    if (Array.isArray(args.rows)) {
      this.selectedTitles2 = args.rows.map((idx) => {
        const item = this.gridObj2.getDataItem(idx);
        return item || "";
      });
    }
  }

  saveReactiveProblemData() {
    // this.ReactiveData = this.selectedTitles2;
    this.modalRef.close();
  }

  saveData() {
    for (let i = 0; i < this.selectedTitles.length; i++) {
      if (this.Tickets.indexOf(this.selectedTitles[i].id) === -1) {
        this.Tickets.push(this.selectedTitles[i].id);
      }
    }
    this.assetCount = this.Tickets.length;
    // this.modalRef.close();
  }

  // getRequesterInfo() {
  //     this.getPSDetails(this.userName, 'login');
  // }

  remove(ticket): void {
    const index = this.Tickets.indexOf(ticket);
    if (index >= 0) {
      this.Tickets.splice(index, 1);
    }
  }

  removeReactiveProblemData(data): void {
    const index = this.addedTicket.indexOf(data);
    if (index >= 0) {
      this.addedTicket.splice(index, 1);
    }
  }

  changeRouting() {
    if (
      this.messageService.dashboardUrl !== undefined &&
      this.messageService.dashboardUrl !== null
    ) {
      this.messageService.changeRouting(this.messageService.dashboardUrl);
    }
    // this.route.navigate(['ticket/dashboard']);
  }

  openModal(content) {
    if (!this.messageService.add) {
      this.notifier.notify("error", "You do not have add permission");
    } else {
      this.data = [];
      this.columnDefinitions = [];
      this.masterNameSelected = 0;
      this.columnNameSelected = 0;
      this.assetValue = "";
      // ======================================= get asset master data =============================================
      this._rest.getAssetManagementMaster(this.clientId).subscribe(
        (res1) => {
          this.respObject = res1;
          if (this.respObject.success) {
            this.masterNameObj = this.respObject.details;
            this.masterNameObj.unshift({
              id: 0,
              masterName: "Select asset master name",
            });
            this.totalData = this.masterNameObj.length;
          } else {
            this.notifier.notify("error", this.respObject.errorMessage);
          }
        },
        (err) => {
          this.notifier.notify("error", this.messageService.SERVER_ERROR);
        }
      );
      this.modalRef = this.modalService.open(content, { size: "lg" });
      this.modalRef.result.then(
        (result) => {},
        (reason) => {}
      );
    }
  }

  ticketModal(contentData) {
    if (!this.messageService.add) {
      this.notifier.notify("error", "You do not have add permission");
    } else {
      this.ticketIdSearchLoaded = true;
      this.filterSearchLoaded = true;
      this.getIncidentCategory();
      this._rest
        .getStatusByTicketTypeForIncident(1, this.clientId)
        .subscribe((res) => {
          this.respObject = res;
          if (this.respObject.success) {
            this.respObject.details.unshift({ id: 0, status: "Select Status" });
            this.allStatus = this.respObject.details;
            this.statusSelected = 0;
          }
        });
      // this.addedTicket = [];
      this.dataset = [];
      this._rest
        .getAttributesHeaderMstClientWiseWithTicket(this.clientId, this.inciId)
        .subscribe(
          (res1) => {
            this.respObject = res1;
            if (this.respObject.success) {
              const data = this.respObject.details;
              const data1 = [];
              this.ticketColumn = [
                {
                  id: "id",
                  name: "Id",
                  field: "id",
                  minWidth: 100,
                  sortable: true,
                  filterable: true,
                },
                {
                  id: "ticket_id",
                  name: "Ticket Id",
                  field: "ticket_id",
                  minWidth: 100,
                  sortable: true,
                  filterable: true,
                },
                {
                  id: "createdBy",
                  name: "Created By",
                  field: "createdBy",
                  minWidth: 100,
                  sortable: true,
                  filterable: true,
                },
                {
                  id: "createdSince",
                  name: "Created Since",
                  field: "createdSince",
                  minWidth: 100,
                  sortable: true,
                  type: FieldType.dateIso,
                  filterable: true,
                },
                {
                  id: "status",
                  name: "Status",
                  field: "status",
                  sortable: true,
                  minWidth: 100,
                  filterable: true,
                },
                {
                  id: "reqInfo",
                  name: "RequesterInfo",
                  field: "reqInfo",
                  minWidth: 100,
                  sortable: true,
                  filterable: true,
                },
                {
                  id: "priority",
                  name: "Priority",
                  field: "priority",
                  minWidth: 100,
                  sortable: true,
                  filterable: true,
                },
                {
                  id: "assignee",
                  name: "Assignee",
                  field: "assignee",
                  minWidth: 100,
                  sortable: true,
                  filterable: true,
                },
                {
                  id: "LEVELSHORTDESC",
                  name: "Group",
                  field: "LEVELSHORTDESC",
                  minWidth: 100,
                  sortable: true,
                  filterable: true,
                },
                {
                  id: "dDate",
                  name: "Due Date",
                  field: "dDate",
                  minWidth: 100,
                  sortable: true,
                  filterable: true,
                  type: FieldType.dateIso,
                },
                {
                  id: "updateDate",
                  name: "Last Update Date",
                  field: "updateDate",
                  minWidth: 100,
                  sortable: true,
                  filterable: true,
                  type: FieldType.dateIso,
                },
                {
                  id: "updateBy",
                  name: "Last Updated By",
                  field: "updateBy",
                  minWidth: 100,
                  sortable: true,
                  filterable: true,
                },
                {
                  id: "closureDate",
                  name: "Closure Date",
                  field: "closureDate",
                  minWidth: 100,
                  sortable: true,
                  filterable: true,
                  type: FieldType.dateIso,
                },
              ];
              for (let j = 0; j < this.columnData2.length; j++) {
                data1.push(this.columnData2[j]);
              }

              for (let k = 0; k < this.ticketColumn.length; k++) {
                data1.push(this.ticketColumn[k]);
              }
              // // console.log('ticket column first:', JSON.stringify(data1));
              for (let i = 0; i < data.length; i++) {
                data1.push({
                  id: data[i].field,
                  name: data[i].name,
                  field: data[i].field,
                  minWidth: 100,
                  sortable: true,
                  filterable: true,
                });
              }
              this.gridObj2.setColumns(data1);
              const classes = document.getElementsByClassName("search-filter");
              for (let i = 0; i < classes.length; i++) {
                classes[i].setAttribute("placeholder", "");
              }
            } else {
              this.notifier.notify("error", this.respObject.errorMessage);
            }
          },
          (err) => {
            this.notifier.notify("error", JSON.stringify(err));
          }
        );
      // ======================================end silk grid ==========================================
      // this.masterNameSelected = 0;

      // const params = {clientId: this.clientId};
      // // console.log('$$$$$$$$$$$$$$$$', params);
      // this._rest.getAllIncidentTicketDetails(this.clientId).subscribe((res1) => {
      //   this.displayTicket(res1);
      // }, (err) => {
      //   this.notifier.notify('error', this.respObject.SERVER_ERROR);
      // });

      this.modalRef = this.modalService.open(contentData, { size: "lg" });
      this.modalRef.result.then(
        (result) => {},
        (reason) => {}
      );
    }
  }

  onResizeEnd(event: ResizeEvent) {
    if (event) {
      // console.log(event);
      if (event.rectangle.height != null) {
        this.height = event.rectangle.height;
      }
    }
  }

  onButtonChange(selectedButton) {
    console.log("+++++++++++++++++", selectedButton, selectedButton.value.id);
    this.radioChecked = selectedButton.value.id;
    this.storage.type = this.radioChecked;
    if (this.parrentTicketId === "") {
      sessionStorage.setItem("dd", JSON.stringify(this.storage));
    }
    this.reactiveSearchDisplay = false;
    this.reactiveRadioCheck = false;

    this.dynamicFields = [];
    if (this.attachment.length > 0) {
      this.attachment = [];
    }
    this.typeSeq = selectedButton.value.seq;
    if (Number(this.typeSeq) === 5) {
      this.hideCr = true;
    } else {
      this.hideCr = false;
    }

    if (Number(this.typeSeq) === 6) {
      this.hidePr = true;
    } else {
      this.hidePr = false;
    }
    this.parentTypeSeq = selectedButton.value.seq;
    this.priority = "";
    this.priorityId = 0;
    this.getTicketLoadingDataWithAttr2();
    this.getRSDBData("2");
    if (
      (this.typeSeq === 1 || this.typeSeq === 5) &&
      selectedButton.value.asset === "true"
    ) {
      this.displayed = true;
    } else {
      this.displayed = false;
    }

    if (this.typeSeq === 2) {
      this.subRadioDisplay = true;
    } else {
      this.subRadioDisplay = false;
    }
  }

  onSubButtonChange(selectedButton) {
    if (this.attachment.length > 0) {
      this.attachment = [];
    }
    // // console.log(typeof selectedButton.value.seq,selectedButton.value.seq)
    if (selectedButton.value.seq === 4) {
      this.reactiveRadioCheck = true;
      this.subRadioDisplay = true;
      this.reactiveSearchDisplay = true;
    } else if (selectedButton.value.seq === 3) {
      this.preventiveRadioCheck = true;
      this.subRadioDisplay = true;
      this.reactiveSearchDisplay = false;
    }
    // this.subTypeSeq = selectedButton.value.seq;
    this.typeSeq = selectedButton.value.seq;
    this.subTypeId = selectedButton.value.id;
  }

  getTicketLoadingData() {
    this._rest
      .getTicketCreateLoadingDtls(
        this.messageService.getUserId(),
        this.radioChecked,
        this.clientId
      )
      .subscribe(
        (res) => {
          this.respObject = res;
          this.categoryLoaded = true;
          if (this.respObject.success) {
            // this.baseCategories = JSON.parse(JSON.stringify(this.respObject.details[0].attribute));
            this.baseCategories = this.messageService.copyArray(
              this.respObject.details[0].attribute
            );
            this.ticketTypes = this.respObject.details[0].attribute;
            console.log(
              "11111111111111111111111111111111111111111111111111111111111"
            );
            this.priorityType = this.respObject.details[0].val.type;
            this.subtypes = this.respObject.details[0].subtype;
            // // console.log(this.priorityType);
            this.cat = [];
            // this.clientId = this.respObject.details[0].clientId;
            this.respObject.details[0].val.urgency.unshift({
              id: 0,
              name: "Select Urgency",
            });
            this.respObject.details[0].val.impact.unshift({
              id: 0,
              name: "Select Bussiness Impact",
            });
            this.urgencies = this.respObject.details[0].val.urgency;
            this.impacts = this.respObject.details[0].val.impact;
            this.urgency = 0;
            this.impact = 0;
            this.priority = "";
          } else {
            this.notifier.notify("error", this.respObject.errorMessage);
          }
        },
        (err) => {
          this.notifier.notify("error", this.messageService.SERVER_ERROR);
        }
      );
  }

  getIncidentCategory() {
    const cat = this.messageService.getCategory1();
    this._rest
      .getTicketCreateLoadingDtlsForSearch(
        this.messageService.getUserId(),
        this.inciId,
        this.clientId,
        cat.cat1,
        cat.cat2,
        this.userGroupSelected,
        this.islead
      )
      .subscribe(
        (res) => {
          this.respObject = res;
          this.categoryLoaded = true;
          if (this.respObject.success) {
            this.inciCategories = this.messageService.copyArray(
              this.respObject.details[0].attribute
            );
          } else {
            this.notifier.notify("error", this.respObject.errorMessage);
          }
        },
        (err) => {
          this.notifier.notify("error", this.messageService.SERVER_ERROR);
        }
      );
  }

  getTicketLoadingDataWithAttr() {
    this._rest
      .getTicketCreateLoadingDtls_citapps(
        this.messageService.getUserId(),
        this.radioChecked,
        this.clientId,
        this.cat1,
        this.cat2,
        this.cat3
      )
      .subscribe(
        (res) => {
          this.respObject = res;
          this.categoryLoaded = true;
          if (this.respObject.success) {
            // this.baseCategories = JSON.parse(JSON.stringify(this.respObject.details[0].attribute));
            this.baseCategories = this.messageService.copyArray(
              this.respObject.details[0].attribute
            );
            this.priorityType = this.respObject.details[0].val.type;
            this.ticketTypes = this.respObject.details[0].attribute;
            this.disabledCount = this.respObject.details[0].disabled;
            this.cat = [];
            this.subtypes = this.respObject.details[0].subtype;

            if (this.subtypes.length > 0) {
              this.subtypes[0].checked = true;
              if (this.subtypes[0].seq === 4) {
                this.reactiveRadioCheck = true;
                this.subRadioDisplay = true;
                this.reactiveSearchDisplay = true;
              } else if (this.subtypes[0].seq === 3) {
                this.preventiveRadioCheck = true;
                this.subRadioDisplay = true;
                this.reactiveSearchDisplay = false;
              }
              // this.subTypeSeq = selectedButton.value.seq;
              this.typeSeq = this.subtypes[0].seq;
              this.subTypeId = this.subtypes[0].id;
            }
          } else {
            this.notifier.notify("error", this.respObject.errorMessage);
          }
        },
        (err) => {
          this.notifier.notify("error", this.messageService.SERVER_ERROR);
        }
      );
  }

  getTicketLoadingDataWithAttr2() {
    // console.log('getTicketLoadingDataWithAttr2 === >');
    this._rest
      .getCreateTicketData(
        this.messageService.getUserId(),
        this.radioChecked,
        this.clientId
      )
      .subscribe(
        (res) => {
          this.respObject = res;
          this.categoryLoaded = true;
          if (this.respObject.success) {
            // this.baseCategories = JSON.parse(JSON.stringify(this.respObject.details[0].attribute));
            this.baseCategories = this.messageService.copyArray(
              this.respObject.details[0].attribute
            );
            this.priorityType = this.respObject.details[0].val.type;
            this.ticketTypes = this.respObject.details[0].attribute;
            this.disabledCount = this.respObject.details[0].disabled;
            this.cat = [];
            this.subtypes = this.respObject.details[0].subtype;

            if (this.subtypes.length > 0) {
              this.subtypes[0].checked = true;
              if (this.subtypes[0].seq === 4) {
                this.reactiveRadioCheck = true;
                this.subRadioDisplay = true;
                this.reactiveSearchDisplay = true;
              } else if (this.subtypes[0].seq === 3) {
                this.preventiveRadioCheck = true;
                this.subRadioDisplay = true;
                this.reactiveSearchDisplay = false;
              }
              // this.subTypeSeq = selectedButton.value.seq;
              this.typeSeq = this.subtypes[0].seq;
              this.subTypeId = this.subtypes[0].id;
            }
          } else {
            this.notifier.notify("error", this.respObject.errorMessage);
          }
        },
        (err) => {
          this.notifier.notify("error", this.messageService.SERVER_ERROR);
        }
      );
  }

  onCategoryChange(ticket, option) {
    // console.log(option);
    // console.log(JSON.stringify(ticket));
    // if(this.ticketTypes)

    const opt = JSON.parse(option);
    if (opt.type !== "header") {
      const value = opt.id;
      let matched = false;
      const index = this.ticketTypes
        .map(function (d) {
          return d["id"];
        })
        .indexOf(ticket.id + 1);
      // // console.log('index:' + index);
      const index1 = this.ticketTypes
        .map(function (d) {
          return d["id"];
        })
        .indexOf(ticket.id);
      let pid;
      // const pid = this.ticketTypes[index1].options[0].id;
      for (let i = 0; i < this.ticketTypes[index1].options.length; i++) {
        if (this.ticketTypes[index1].options[i].type) {
          // console.log('inside');
          pid = this.ticketTypes[index1].options[i].id;
        }
      }
      if (index1 === this.disabledCount) {
        // console.log('inside index'+this.cat.length);
        if (this.cat.length === 0) {
          let pid1, cid1;
          for (let i = 0; i < this.disabledCount; i++) {
            pid1 = this.baseCategories[i].options[1].id;
            cid1 = this.baseCategories[i].options[0].id;
            this.cat.push({ pid: pid1, cid: cid1 });
          }
        }
      }
      if (this.cat.length === 0) {
        this.cat.push({ pid: pid, cid: value });
      } else {
        for (let i = 0; i < this.cat.length; i++) {
          if (this.cat[i].pid === pid) {
            matched = true;
            this.cat[i].cid = value;
            break;
          }
        }
        if (!matched) {
          this.cat.push({ pid: pid, cid: value });
        } else {
          for (let i = index; i < this.cat.length; i++) {
            // // console.log('matched');
            // // console.log(this.cat[i]);
            if (index > -1) {
              this.cat[i].cid = 0;
            }
          }
        }
      }
      if (index > -1) {
        // console.log('index:' + index);
        for (let i = index + 1; i < this.ticketTypes.length; i++) {
          const options = this.ticketTypes[i].options;
          // console.log(JSON.stringify(options));
          for (let j = 0; j < options.length; j++) {
            if (options[j].type) {
              // options=[];
              this.ticketTypes[i].options = [options[j]];
              break;
            }
          }
        }
      }
      if (index === 2 && (this.typeSeq === 1 || this.typeSeq === 27)) {
        this.selectedCatVal = value;
        this.getRSDBData("1");
      }
      let cats = "";
      const catsArr = [];
      for (let i = 0; i < this.cat.length; i++) {
        if (this.cat[i].cid !== 0) {
          catsArr.push(this.cat[i]);
          // categoryName += this.cat[i].pid + '#' + this.cat[i].cid;
        }
      }
      for (let i = 0; i < catsArr.length; i++) {
        if (catsArr[i].cid !== 0) {
          if (i === catsArr.length - 1) {
            cats += catsArr[i].cid;
          } else {
            cats += catsArr[i].cid + ",";
          }
          // categoryName += this.cat[i].pid + '#' + this.cat[i].cid;
        }
      }
      this._rest
        .getTicketFieldsCatWise({
          clientId: this.clientId,
          catId: cats,
          ticketTypeId: this.radioChecked,
        })
        .subscribe(
          (res) => {
            this.respObject = res;
            if (this.respObject.success) {
              let isChild = false;
              // // console.log(JSON.stringify(this.respObject.details));
              for (let i = 0; i < this.respObject.details.length; i++) {
                if (this.respObject.details[i].predifinedValue !== null) {
                  this.respObject.details[i].values =
                    this.respObject.details[i].predifinedValue.split(",");
                  this.respObject.details[i].value =
                    this.respObject.details[i].values[0];
                } else {
                  this.respObject.details[i].value = "";
                }
                if (this.respObject.details[i].type === "child") {
                  isChild = true;
                }
              }
              this.dynamicFields = this.respObject.details;
              if (isChild) {
                this.isContractDisabled = false;
              } else {
                this.isContractDisabled = true;
                this.isContractUser = false;
              }
            } else {
            }
          },
          (err) => {}
        );
      // // console.log('index:'+index);
      let data;
      if (index > -1) {
        for (let k = 0; k < this.ticketTypes[index].options.length; k++) {
          if (this.ticketTypes[index].options[k].type) {
            data = this.ticketTypes[index].options[k];
          }
        }
        this.ticketTypes[index].options = [];
        this.dataLoaded = false;
      }
      this._rest
        .getAttributesParentWiseWithPriority(
          this.clientId,
          value,
          this.priorityType,
          this.radioChecked
        )
        .subscribe(
          (res) => {
            let respObject;
            respObject = res;
            // console.log(JSON.stringify(respObject));

            if (respObject.success) {
              this.dataLoaded = true;
              if (respObject.details.val) {
                // data = this.ticketTypes[index].options[0];
                let singleValue = false;
                if (respObject.details.val.length === 1) {
                  singleValue = true;
                }
                if (singleValue) {
                  respObject.details.val.push(data);
                } else {
                  respObject.details.val.unshift(data);
                }
                this.ticketTypes[index].options = respObject.details.val;
                if (singleValue) {
                  this.onCategoryChange(
                    this.ticketTypes[index],
                    JSON.stringify(respObject.details.val[0])
                  );
                }
              }
              if (respObject.details.priority) {
                this.priority = respObject.details.priority.name;
                this.priorityId = respObject.details.priority.id;
              }
            } else {
              this.dataLoaded = true;
              if (index > -1) {
                this.ticketTypes[index].options = [data];
              }
              // this.notifier.notify('error', this.respObject.errorMessage);
            }
          },
          (err) => {
            // this.notifier.notify('error', this.messageService.SERVER_ERROR);
          }
        );
    }
  }

  showDataLoader(value) {
    // console.log('loaderrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrr==' + this.dataLoaded);
    this.dataLoaded = value.dataLoaded;
  }

  onSearchCategoryChange(ticket, option) {
    // console.log(JSON.stringify(option), typeof option, ticket.id);
    // if(this.ticketTypes)

    const opt = JSON.parse(option);
    if (opt.type !== "header") {
      // if (this.attachment.length > 0) {
      //   this.attachment = [];
      // }
      const value = opt.id;
      let matched = false;
      const index = this.inciCategories
        .map(function (d) {
          return d["id"];
        })
        .indexOf(ticket.id + 1);
      // // console.log('index:' + index);
      const index1 = this.inciCategories
        .map(function (d) {
          return d["id"];
        })
        .indexOf(ticket.id);
      const pid = this.inciCategories[index1].options[0].id;
      // // console.log(this.ticketTypes[index1].options[0]);
      // if (index === 3) {
      //     const pid1 = this.baseCategories[0].options[1].id;
      //     const pid2 = this.baseCategories[1].options[1].id;
      //     const cid1 = this.baseCategories[0].options[0].id;
      //     const cid2 = this.baseCategories[1].options[0].id;
      //     if (this.searchCat.length === 0) {
      //         this.searchCat.push({pid: pid1, cid: cid1}, {pid: pid2, cid: cid2});
      //     }
      // }
      if (this.searchCat.length === 0) {
        this.searchCat.push({ pid: pid, cid: value });
      } else {
        for (let i = 0; i < this.searchCat.length; i++) {
          if (this.searchCat[i].pid === pid) {
            matched = true;
            this.searchCat[i].cid = value;
            break;
          }
        }
        if (!matched) {
          this.searchCat.push({ pid: pid, cid: value });
        } else {
          for (let i = index; i < this.searchCat.length; i++) {
            // // console.log('matched');
            // // console.log(this.cat[i]);
            if (index > -1) {
              this.searchCat[i].cid = 0;
            }
          }
        }
      }
      // clear sub categories
      if (index > -1) {
        // console.log('index:' + index);
        for (let i = index + 1; i < this.inciCategories.length; i++) {
          const options = this.inciCategories[i].options;
          // console.log(JSON.stringify(options));
          for (let j = 0; j < options.length; j++) {
            if (options[j].type) {
              // options=[];
              this.inciCategories[i].options = [options[j]];
              break;
            }
          }
        }
      }
      let data;
      if (index > -1) {
        data = this.ticketTypes[index].options[0];
        this.inciCategories[index].options = [];
      }
      this._rest
        .getAttributesParentWiseWithPriority(
          this.clientId,
          value,
          this.priorityType,
          this.radioChecked
        )
        .subscribe(
          (res) => {
            this.respObject = res;
            // // console.log(JSON.stringify(this.respObject));
            // let data;
            // if (index > -1) {
            //     data = this.inciCategories[index].options[0];
            // }
            if (this.respObject.success) {
              if (this.respObject.details.val) {
                // data = this.ticketTypes[index].options[0];
                this.respObject.details.val.unshift(data);
                this.inciCategories[index].options =
                  this.respObject.details.val;
              }
            } else {
              if (index > -1) {
                this.inciCategories[index].options = [data];
              }
              // this.notifier.notify('error', this.respObject.errorMessage);
            }
          },
          (err) => {
            this.notifier.notify("error", this.messageService.SERVER_ERROR);
          }
        );
    }
  }

  getRSDBData(type) {
    console.log("inside getRSDBData ");

    this.rsdbData = [];
    this.selectedTab = 0;
    this._rest
      .getRSDBData(
        this.clientId,
        this.radioChecked,
        this.selectedCatVal,
        this.messageService.getUserId(),
        this.createbyId,
        type
      )
      .subscribe(
        (res) => {
          this.respObject = res;
          console.log("getRSDBData this.respObject ===", this.respObject);

          if (this.respObject.success) {
            this.rsdbData = this.respObject.details;
          } else {
            // this.notifier.notify('error', this.respObject.errorMessage);
          }
        },
        (err) => {
          // this.notifier.notify('error', this.messageService.SERVER_ERROR);
        }
      );
  }

  onImpactChange(value) {
    if (this.urgency !== 0) {
      this._rest
        .getBusinessPriorityImpactUrgencyBasis(
          this.clientId,
          this.impact,
          this.urgency
        )
        .subscribe(
          (res) => {
            this.respObject = res;
            if (this.respObject.success) {
              this.priority = this.respObject.details.name;
              this.priorityId = this.respObject.details.id;
            } else {
              this.notifier.notify("error", this.respObject.errorMessage);
            }
          },
          (err) => {
            this.notifier.notify("error", this.messageService.SERVER_ERROR);
          }
        );
    }
  }

  onUrgencyChange(value) {
    if (this.impact !== 0) {
      this._rest
        .getBusinessPriorityImpactUrgencyBasis(
          this.clientId,
          this.impact,
          this.urgency
        )
        .subscribe(
          (res) => {
            this.respObject = res;
            if (this.respObject.success) {
              this.priority = this.respObject.details.name;
              this.priorityId = this.respObject.details.id;
            } else {
              this.notifier.notify("error", this.respObject.errorMessage);
            }
          },
          (err) => {
            this.notifier.notify("error", this.messageService.SERVER_ERROR);
          }
        );
    }
  }

  resetField() {
    // this.name = this.userName + '-' + this.messageService.xorEncode(atob(this.email), this.messageService.SECRET_TOKEN) +
    //   '-' + this.messageService.xorEncode(atob(this.mobile), this.messageService.SECRET_TOKEN);
    this.attachFile = 0;
    this.desc = "";
    this.brief = "";
    this.rDate = "";
    this.dDate = "";
    this.impact = 0;
    this.urgency = 0;
    this.attachment = [];
    this.isContractUser = false;
    this.hideAttachment = true;
    this.cat = [];
    this.selectedTitles2 = [];
    this.claimNo = "";
    this.searchDtls = [];
    this.isBlankLong = false;
    this.isBlankDesc = false;
    this.isBlankRequester = false;
    this.isBlankClaim = false;
    this.isBlankPriority = false;
    this.priority = "";
    this.priorityId = 0;
    this.selectedCatVal = 0;
    // // console.log(JSON.stringify(this.baseCategories));
    this.ticketTypes = this.messageService.copyArray(this.baseCategories);
    this.Tickets = [];
    this.addedTicket = [];
    this.userSelected = "";
    const progressbar = document.getElementById("progressbar");
    if (progressbar !== null && progressbar !== undefined) {
      progressbar.remove();
    }
    const fileLabel = document.getElementById("file-label");
    if (fileLabel !== null && progressbar !== undefined) {
      fileLabel.remove();
    }
    this.dynamicFields = [];
    // for (let i = 0; i < this.dynamicFields.length; i++) {
    //     if (this.dynamicFields[i].fieldType === '1') {
    //         this.dynamicFields[i].value = '';
    //     }
    //     if (this.dynamicFields[i].fieldType === '3') {
    //         this.dynamicFields[i].value = this.dynamicFields[i].values[0];
    //     }
    // }
    this.isContractDisabled = true;
    if (this.grpLevel !== 0) {
      this.name = "";
      this.rsdbData = [];
    }
  }

  createTicket() {
    if (!this.messageService.add) {
      this.notifier.notify("error", "You do not have add permission");
    } else {
      let cats = "";
      let extrafields = "";
      let isError = false;
      let incIds = "";
      const assetIds = [];
      let extraCount = 0;
      let isAddFieldMissing = false;
      // console.log(JSON.stringify(this.cat));
      if (this.cat.length === this.ticketTypes.length) {
        for (let i = 0; i < this.cat.length; i++) {
          if (this.cat[i].cid !== 0) {
            cats += this.cat[i].pid + "#" + this.cat[i].cid;
            if (i !== this.cat.length - 1) {
              cats += ",";
            }
          } else {
            isError = true;
            break;
          }
        }
      } else {
        isError = true;
      }
      // // console.log(cats);
      // // console.log(JSON.stringify(this.dynamicFields));
      for (let j = 0; j < this.Tickets.length; j++) {
        assetIds.push(this.Tickets[j]);
      }

      for (let i = 0; i < this.dynamicFields.length; i++) {
        if (this.isContractUser) {
          if (
            this.dynamicFields[i].value !== "" &&
            this.dynamicFields[i].value !== "NONE"
          ) {
            extraCount++;
            if (i === this.dynamicFields.length - 1) {
              extrafields +=
                this.dynamicFields[i].id + "@" + this.dynamicFields[i].value;
            } else {
              extrafields +=
                this.dynamicFields[i].id +
                "@" +
                this.dynamicFields[i].value +
                "#";
            }
          }
        } else {
          if (this.dynamicFields[i].type === "child") {
            extraCount++;
          } else {
            if (
              this.dynamicFields[i].value !== "" &&
              this.dynamicFields[i].value !== "NONE"
            ) {
              extraCount++;
              if (i === this.dynamicFields.length - 1) {
                extrafields +=
                  this.dynamicFields[i].id + "@" + this.dynamicFields[i].value;
              } else {
                extrafields +=
                  this.dynamicFields[i].id +
                  "@" +
                  this.dynamicFields[i].value +
                  "#";
              }
            }
          }
        }
      }
      if (extraCount !== this.dynamicFields.length) {
        isAddFieldMissing = true;
      }
      extrafields =
        extrafields.substring(extrafields.length - 1, extrafields.length) ===
        "#"
          ? extrafields.substring(0, extrafields.length - 1)
          : extrafields;
      let noIncident = false;
      if (this.typeSeq === 4) {
        if (this.addedTicket.length > 0) {
          for (let i = 0; i < this.addedTicket.length; i++) {
            if (i === this.addedTicket.length - 1) {
              incIds += this.addedTicket[i];
            } else {
              incIds += this.addedTicket[i] + ",";
            }
          }
        } else {
          noIncident = true;
        }
      }
      if (noIncident) {
        this.notifier.notify("error", this.messageService.INCIDENT_ERROR);
      } else {
        if (isError) {
          this.notifier.notify("error", this.messageService.CATEGORY_ERROR);
        } else if (isAddFieldMissing) {
          this.notifier.notify(
            "error",
            this.messageService.ADDITIONAL_FIELD_ERROR
          );
        } else {
          let data;
          const sourceType = this.messageService.getSourceType();
          if (sourceType !== null) {
            this.sourceType = sourceType;
          }
          if (this.priorityType === 1) {
            data = {
              ticket_type_seq: this.typeSeq,
              clientId: this.clientId,
              user_id: this.messageService.getUserId(),
              ticketTypeId: this.radioChecked,
              // 'requesterInfo': this.name,
              tName: this.desc,
              longDesc: this.brief,
              attachmentPath: this.attachment,
              busi_priority_id: this.priorityId,
              tstatus: 1,
              // 'requestedDate': this.rDate,
              // 'dueDate': this.dDate,
              busi_impact_id: this.impact,
              busi_urgency_id: this.urgency,
              createdBy: this.createbyId,
              categoryDtlsLt: cats,
              priorityType: this.priorityType,
              sourceType: this.sourceType,
              original_createdbyid: this.messageService.getUserId(),
              userGroupId: this.userGroupId,
              // 'fieldValueDtls': extrafields
            };
          } else if (this.priorityType === 2) {
            data = {
              ticket_type_seq: this.typeSeq,
              clientId: this.clientId,
              user_id: this.messageService.getUserId(),
              ticketTypeId: this.radioChecked,
              // 'requesterInfo': this.name,
              tName: this.desc,
              longDesc: this.brief,
              attachmentPath: this.attachment,
              busi_priority_id: this.priorityId,
              tstatus: 1,
              // 'requestedDate': this.rDate,
              // 'dueDate': this.dDate,
              createdBy: this.createbyId,
              categoryDtlsLt: cats,
              priorityType: this.priorityType,
              sourceType: this.sourceType,
              original_createdbyid: this.messageService.getUserId(),
              userGroupId: this.userGroupId,
              // 'fieldValueDtls': extrafields
            };
          }
          if (!this.hideClaim) {
            data["claimNo"] = this.claimNo;
            if (this.claimNo.trim() === "") {
              this.isBlankClaim = true;
            } else {
              this.isBlankClaim = false;
            }
          }
          if (this.typeSeq === 1) {
            data["requesterInfo"] = this.name;
            if (this.name.trim() === "") {
              this.isBlankRequester = true;
            } else {
              this.isBlankRequester = false;
            }
          }
          if (this.desc.trim() === "") {
            this.isBlankDesc = true;
          } else {
            this.isBlankDesc = false;
          }
          if (this.brief.trim() === "") {
            this.isBlankLong = true;
          } else {
            this.isBlankLong = false;
          }
          if (this.priorityId === 0) {
            this.isBlankPriority = true;
          } else {
            this.isBlankPriority = false;
          }
          // console.log('before : ' + JSON.stringify(data));
          if (!this.messageService.isBlankField(data)) {
            // data['requestedDate'] = this.rDate;
            // data['dueDate'] = this.dDate;
            if (this.parrentTicketId !== "") {
              data["parrent_id"] = this.parrentTicketId;
            }
            if (this.wfcresultId !== "") {
              data["wfcclient_id"] = this.wfcresultId;
            }
            if (this.typeSeq !== 1) {
              data["requesterInfo"] = this.name;
            }
            if (extrafields !== "") {
              data["fieldValueDtls"] = extrafields;
            }
            if (assetIds.length > 0) {
              data["assetIds"] = assetIds;
            }
            if (this.typeSeq === 4) {
              data["incident_ticket_list"] = incIds;
              data["sub_ticket_type"] = this.subTypeId;
            }
            if (this.typeSeq === 3) {
              data["sub_ticket_type"] = this.subTypeId;
            }
            data["psDetails"] = this.psDetails;
            // console.log(JSON.stringify(data));
            this.dataLoaded = false;
            // const fileUpload = document.getElementById('fileUpload') as HTMLInputElement;
            if (this.attachFile > 0) {
              this.notifier.notify(
                "error",
                "Please upload the file by clicking upload button before" +
                  " clicking the create ticket button"
              );
              this.dataLoaded = true;
            } else {
              this._rest.createTicket(data).subscribe(
                (res) => {
                  this.respObject = res;
                  this.dataLoaded = true;
                  if (this.respObject.success) {
                    const msg = this.respObject.id;
                    this.resetField();
                    if (this.parrentTicketId !== "") {
                      this.messageService.setTicketData();
                    }
                    this.notifier.notify(
                      "success",
                      "Your Ticket number is: " + msg
                    );
                  } else {
                    this.notifier.notify("error", this.respObject.errorMessage);
                  }
                },
                (err) => {
                  // this.notifier.notify('error', this.messageService.SERVER_ERROR);
                }
              );
            }
          } else {
            this.notifier.notify(
              "error",
              this.messageService.BLANK_ERROR_MESSAGE
            );
          }
        }
      }
    }
  }

  onFileComplete(data: any) {
    if (data.success) {
      this.hideAttachment = false;
      this.attachFile = 0;
      if (this.attachment.length > this.MAX_FILE_UPLOAD - 1) {
        this.attachMsg =
          "More than " + this.MAX_FILE_UPLOAD + " files is not permitted";
      } else {
        this.attachment.push({
          originalName: data.fileName,
          fileName: data.changedName,
        });
        if (this.attachment.length > 1) {
          this.attachMsg =
            this.attachment.length + " files uploaded successfully";
        } else {
          this.attachMsg =
            this.attachment.length + " file uploaded successfully";
        }
      }
    }
  }

  onUpload(data: any) {
    this.dataLoaded = data.loader;
  }

  onMasterChange(value: any) {
    this.masterName = this.masterNameObj[value].masterName;
    // =================================== get column name================================
    this._rest
      .getAssetColumnByMaster(this.clientId, this.masterNameSelected)
      .subscribe(
        (res) => {
          this.respObject = res;
          // // console.log(this.respObject)
          if (this.respObject.success) {
            const data = this.respObject.details;
            this.columnDataObj = data;
            this.columnDataObj.unshift({
              columnId: 0,
              columnName: "Select asset column name",
            });
            this.totalData = data.length;
          } else {
            this.notifier.notify("error", this.respObject.errorMessage);
          }
        },
        (err) => {
          this.notifier.notify("error", this.messageService.SERVER_ERROR);
        }
      );
    // =============================================================================================================
  }

  onClientChange(value: any) {
    this.columnName = this.columnDataObj[value].columnName;
  }

  submitAssetData() {
    this.searchAssetmanagement(this.page);
  }

  onPageChange(event) {
    this.page = event;
    this.searchAssetmanagement(this.page);
  }

  searchAssetmanagement(page) {
    this._rest
      .searchAssetManagementData(
        this.clientId,
        this.masterNameSelected,
        this.columnNameSelected,
        this.assetValue,
        this.page,
        this.pageSize
      )
      .subscribe(
        (res) => {
          this.respObject = res;
          // // console.log(this.respObject)
          if (this.respObject.success) {
            this.gridObj.getSelectionModel().setSelectedRanges([]);
            this.data = [];
            const data1 = [];
            for (let i = 0; i < this.columnData.length; i++) {
              data1.push(this.columnData[i]);
            }
            const data = this.respObject.details;
            this.columnNameObj = data.columnObj;
            this.columnValueObj = data.valueObj;
            data1.push({
              id: "id",
              name: "Id",
              field: "id",
              sortable: true,
              filterable: true,
            });
            data1.push({
              id: "description",
              name: "descriptionId",
              field: "description",
              sortable: true,
              filterable: true,
            });
            for (let i = 0; i < this.columnNameObj.length; i++) {
              data1.push({
                id: this.columnNameObj[i].columnName,
                name: this.columnNameObj[i].columnName,
                field: this.columnNameObj[i].id,
                sortable: true,
                filterable: true,
              });
            }
            this.gridObj.setColumns(data1);
            const colval = [];
            if (this.columnValueObj !== null) {
              for (let j = 0; j < this.columnValueObj.length; j++) {
                this.columVal = this.columnValueObj[j].columVal;
                this.descId = this.columnValueObj[j].id;
                const description = this.columnValueObj[j].description;
                const columnValue = this.columVal.split(",");
                // // console.log('column=', JSON.stringify(columnValue));
                const jsonval = {};
                jsonval["id"] = this.descId;
                jsonval["description"] = description;
                for (let k = 0; k < columnValue.length; k++) {
                  this.attrVal = columnValue[k];
                  this.attrValue = this.attrVal.split(":");

                  jsonval[this.attrValue[0]] = this.attrValue[1];
                }
                colval.push(jsonval);
                this.collectionSize = this.columnValueObj[j].totalData;
              }
            }
            this.data = colval;
          } else {
            this.notifier.notify("error", this.respObject.errorMessage);
          }
        },
        (err) => {
          this.notifier.notify("error", this.messageService.SERVER_ERROR);
        }
      );
  }

  searchTicket() {
    if (this.searchTid && this.searchTid !== "") {
      const data = {
        ticketId: this.searchTid,
        clientId: this.clientId,
      };
      this.ticketIdSearchLoaded = false;
      this._rest.getTicketById(data).subscribe(
        (res1) => {
          this.respObject = res1;
          this.ticketIdSearchLoaded = true;
          // // console.log(JSON.stringify(this.respObject));
          if (this.respObject.success) {
            this.gridObj2.getSelectionModel().setSelectedRanges([]);
            this.searchTid = "";
            for (let i = 0; i < this.respObject.details.length; i++) {
              this.respObject.details[i].createdSince =
                this.messageService.datePipeFunc(
                  this.respObject.details[i].createdSince
                );
              this.respObject.details[i].dDate =
                this.messageService.datePipeFunc(
                  this.respObject.details[i].dDate
                );
              this.respObject.details[i].updateDate =
                this.messageService.datePipeFunc(
                  this.respObject.details[i].updateDate
                );
              if (this.respObject.details[i].closureDate === undefined) {
                this.respObject.details[i].closureDate = "";
              } else {
                this.respObject.details[i].closureDate =
                  this.messageService.datePipeFunc(
                    this.respObject.details[i].closureDate
                  );
              }
              this.respObject.details[i].requestedDate =
                this.messageService.datePipeFunc(
                  this.respObject.details[i].requestedDate
                );
            }
            this.dataset = this.respObject.details;
            this.totalItems = this.respObject.details.length;
          } else {
            alert(this.respObject.errorMessage);
          }
        },
        (err) => {
          // this.notifier.notify('error', this.messageService.SERVER_ERROR);
        }
      );
    } else {
      alert(this.messageService.BLANK_TICKETID);
    }
  }

  addTicket() {
    // this.addedTicket = [];
    for (let i = 0; i < this.selectedTitles2.length; i++) {
      // console.log('AAAAAAAAAAAAAA===', this.addedTicket.indexOf(this.selectedTitles2[i]));
      if (this.addedTicket.indexOf(this.selectedTitles2[i].id) === -1) {
        // console.log('addedTicket0000000000000====', JSON.stringify(this.addedTicket));
        this.addedTicket.push(this.selectedTitles2[i].id);
      }
    }
    // console.log('addedTicket11111====', JSON.stringify(this.addedTicket));
    this.ticketCount = this.addedTicket.length;
  }

  ngOnDestroy(): void {
    if (this.userAuth) {
      this.userAuth.unsubscribe();
    }
    if (this.ticketTypeSubscription) {
      this.ticketTypeSubscription.unsubscribe();
    }
    this.dialogRef = null;
  }

  clickRsdb(id: any) {
    this.tId = id;
    this._rest.getTicketDetailForRSDB(id, this.radioChecked).subscribe(
      (res1) => {
        this.respObject = res1;
        if (this.respObject.success) {
          this.respObject.details.requestedDate =
            this.messageService.datePipeFunc(
              this.respObject.details.requestedDate
            );
          this.respObject.details.dDate = this.messageService.datePipeFunc(
            this.respObject.details.dDate
          );
          this.ticketDetails = this.respObject.details;
          this.messageService.setModalData(this.ticketDetails);
          // this.modalRef = this.modalService.open(this.ticketcontent, {size: 'lg'});
        } else {
          alert(this.respObject.errorMessage);
        }
      },
      (err) => {
        // this.notifier.notify('error', this.messageService.SERVER_ERROR);
      }
    );
  }

  openTicketDetailsModal() {
    console.log("openTicketDetailsModal ===== >>>", this.loginName);

    const dialogRef1 = this.dialog.open(this.loginName, {
      width: "250px",
    });

    console.log("openTicketDetailsModal dialogRef1 ===== >>>", dialogRef1);
  }

  // openTicketDetailsModal() {
  //     const dialogRef = this.dialog.open(YourModalComponent, {
  //         width: '250px',
  //         data: { /* pass any necessary data */ }
  //     });

  //     dialogRef.afterClosed().subscribe(result => {
  //       if (result) {
  //         this.name = result.name;
  //         this.createbyId = result.createbyId;
  //         // Update other fields as necessary
  //       }
  //     });
  //   }

  tabClick(event) {
    if (event.tab.textLabel === "Solutions") {
      this.getSolutions();
    }
  }

  getSolutions() {
    this._rest.getSolutionsTicketWise(this.tId).subscribe(
      (res1) => {
        this.respObject = res1;
        // // console.log(JSON.stringify(this.respObject));
        if (this.respObject.success) {
          this.solutions = this.respObject.details;
        } else {
          // this.notifier.notify('error', this.respObject.errorMessage);
        }
      },
      (err) => {
        // this.notifier.notify('error', this.messageService.SERVER_ERROR);
      }
    );
  }

  getRequesterInfoDetails() {
    this._rest.getUserDetailsByLoginId(this.clientId, this.userName).subscribe(
      (res1) => {
        this.respObject = res1;
        console.log(
          "getRequesterInfoDetails ====",
          JSON.stringify(this.respObject)
        );
        this.dialog.closeAll();
        if (this.respObject.success) {
          // this.solutions = this.respObject.details;
          // this.createbyId = this.respObject.details[0].id;
          // this.name = this.empId + '-' + this.respObject.details[0].name;
          this.name =
            this.userName +
            "-" +
            this.messageService.xorEncode(
              atob(this.respObject.details[0].email),
              this.messageService.SECRET_TOKEN
            ) +
            "-" +
            this.messageService.xorEncode(
              atob(this.respObject.details[0].mobile),
              this.messageService.SECRET_TOKEN
            ) +
            "-" +
            this.respObject.details[0].address;

          console.log("this.name==", this.name);
        } else {
          this.notifier.notify("error", this.respObject.errorMessage);
        }
      },
      (err) => {
        this.notifier.notify("error", this.messageService.SERVER_ERROR);
      }
    );
  }

  // changeId($event) {
  //     this.sourceType = 'Call';
  //     this.getPSDetails(this.empId, 'change');
  //     this.dialog.closeAll();
  // }

  onFileError(msg: string) {
    this.notifier.notify("error", msg);
  }

  searchTicketWithFilter(query, isNewSearch) {
    if (isNewSearch === 1) {
      this.service.resetPaginationOptions();
      this.gridOptions2.pagination.totalItems = 0;
      this.nextOffset = 1;
      if (this.searchPageSize === 0) {
        query = "$top=" + defaultPageSize;
      } else {
        query = "$top=" + this.searchPageSize;
      }
    }
    const queryParams = query.toLowerCase().split("&");
    for (const param of queryParams) {
      // console.log('param====' + JSON.stringify(param) + '==============' + param.includes('$skip='));
      if (param.includes("$top=")) {
        this.top = +param.substring("$top=".length);
      }
      if (param.includes("$skip=")) {
        this.skip = +param.substring("$skip=".length);
      } else {
        this.skip = 0;
      }
    }
    if (this.searchPageSize === 0) {
      this.searchPageSize = defaultPageSize;
    } else {
      this.searchPageSize = this.top;
    }
    this.nextOffset = this.skip;
    const tdate = this.messageService.ticketConverter(this.toDate, 1);
    if (tdate !== "") {
      this.toDate = tdate;
    } else {
      this.toDate = this.endDate;
    }
    const fdate = this.messageService.ticketConverter(this.fromDate, 1);
    if (fdate !== "") {
      this.fromDate = fdate;
    } else {
      this.fromDate = this.startDate;
    }
    this.filterSearchLoaded = false;
    let cats = "";
    for (let i = 0; i < this.searchCat.length; i++) {
      if (this.searchCat[i].cid !== 0) {
        cats += this.searchCat[i].pid + "#" + this.searchCat[i].cid;
        if (i !== this.searchCat.length - 1) {
          cats += ",";
        }
      }
    }
    // const startDate = this.messageService.ticketConverter(this.startDate, 1);
    // const endDate = this.messageService.ticketConverter(this.endDate, 1);
    // console.log(startDate, endDate, this.statusSelected);
    const data = {
      ticketTypeId: this.inciId,
      clientId: this.clientId,
      supportgrp_id: this.userGroupSelected,
      ticketStatusId: this.statusSelected,
      ticket_id: 0,
      busi_priority_id: 0,
      created_frdate: this.fromDate,
      created_todate: this.toDate,
      catFilterLt: cats,
      isTeamLead: "N",
      isDashboardSearch: 0,
      ticketTypeSeqNo: 1,
      page_size: this.searchPageSize,
      nextOffset: this.nextOffset,
    };
    this._rest.AdvancesearchForIncidentTicket(data).subscribe((res) => {
      this.respObject = res;
      this.filterSearchLoaded = true;
      if (this.respObject.success) {
        this.gridObj2.getSelectionModel().setSelectedRanges([]);
        for (let i = 0; i < this.respObject.details.dataObj.length; i++) {
          this.respObject.details.dataObj[i].createdSince =
            this.messageService.datePipeFunc(
              this.respObject.details.dataObj[i].createdSince
            );
          this.respObject.details.dataObj[i].dDate =
            this.messageService.datePipeFunc(
              this.respObject.details.dataObj[i].dDate
            );
          this.respObject.details.dataObj[i].updateDate =
            this.messageService.datePipeFunc(
              this.respObject.details.dataObj[i].updateDate
            );
          if (this.respObject.details.dataObj[i].closureDate === undefined) {
            this.respObject.details.dataObj[i].closureDate = "";
          } else {
            this.respObject.details.dataObj[i].closureDate =
              this.messageService.datePipeFunc(
                this.respObject.details.dataObj[i].closureDate
              );
          }
          this.respObject.details.dataObj[i].requestedDate =
            this.messageService.datePipeFunc(
              this.respObject.details.dataObj[i].requestedDate
            );
        }
        this.dataset = this.respObject.details.dataObj;
        if (this.nextOffset === 0) {
          this.gridOptions2.pagination.totalItems =
            this.respObject.details.totalData[0].count;
          this.totalItems = this.respObject.details.totalData[0].count;
        }
        this.gridOptions2 = Object.assign({}, this.gridOptions2);
      } else {
        alert(this.respObject.errorMessage);
      }
    });
  }

  onUserChange() {
    if (this.isContractUser) {
      const allHideClass = document.querySelectorAll(".child.none");
      for (let i = 0; i < allHideClass.length; i++) {
        allHideClass[i].classList.remove("none");
      }
    } else {
      const allShowClass = document.querySelectorAll(".child");
      for (let i = 0; i < allShowClass.length; i++) {
        allShowClass[i].classList.add("none");
      }
    }
  }

  onFileAttach() {
    this.attachFile = this.attachFile + 1;
  }

  onRemove() {
    this.attachFile = this.attachFile - 1;
  }
}
